export default {
  createSuccess: "¡Agente de ventas creado correctamente!",
  scopeAssigned: "Asignación guardada",
  scopeRemoved: "Asignación eliminada",
  removeScopeError: "No se pudo quitar la asignación",
  create: {
    title: "Crear agente de ventas",
    namePlaceholder: "Nombre visible",
    emailPlaceholder: "agente@example.com",
    submit: "Crear",
  },
  detail: {
    invalidRoute: "Ruta no válida.",
    roleLabel: "Agente de ventas",
    statAssociations: "Usuarios asociados",
    loadDetail: "Cargando datos del agente...",
    loadError: "No se pudo cargar el agente de ventas",
    toastStatusUpdated: "Estado del agente actualizado",
    toastStatusError: "No se pudo actualizar el estado del agente",
    scopedHelp:
      "Asigne este agente a actividades o estructuras concretas con una comisión.",
    activitySection: "Actividades",
    houseSection: "Estructuras",
    addActivity: "Asignar actividad",
    addHouse: "Asignar estructura",
    colActivity: "Actividad",
    colHouse: "Estructura",
    colOwner: "Propietario",
    colHost: "Anfitrión",
    colSaRate: "Cuota del agente",
    emptyActivities: "Aún no hay actividades asignadas.",
    emptyHouses: "Aún no hay estructuras asignadas.",
    remove: "Quitar",
    removeConfirmActivity:
      "¿Quitar la asignación del agente de ventas para esta actividad?",
    removeConfirmHouse:
      "¿Quitar la asignación del agente de ventas para esta estructura?",
    modalActivityTitle: "Asignar actividad",
    modalActivitySubtitle:
      "Elija una actividad y establezca la comisión que gana este agente en las reservas de esa actividad.",
    modalHouseTitle: "Asignar estructura",
    modalHouseSubtitle:
      "Elija una estructura y establezca la comisión que gana este agente en las reservas de esa estructura.",
    selectActivityStep: "Seleccionar actividad",
    selectStructureStep: "Seleccionar estructura",
    searchActivitiesPlaceholder:
      "Buscar por actividad o nombre del propietario…",
    searchStructuresPlaceholder:
      "Buscar por estructura o nombre del propietario…",
    noActivitiesFound: "No se encontraron actividades.",
    noStructuresFound: "No se encontraron estructuras.",
    saCommissionPercentLabel: "Comisión del agente (%)",
    invalidCommission: "Introduzca una comisión válida.",
  },
  associations: {
    title: "Sus asignaciones",
    description:
      "Cada fila es una actividad o una estructura asignada, con su porcentaje de comisión",
    loading: "Cargando asignaciones...",
    errorLoad: "No se pudieron cargar las asignaciones",
    colName: "Actividad / estructura",
    colOwner: "Propietario (id de usuario)",
    colRate: "Su tarifa",
    scopeActivity: "Actividad",
    scopeHouse: "Estructura",
    statActivities: "Actividades",
    statHouses: "Estructuras",
    statTopRate: "Tasa más alta",
    empty:
      "Aún no hay asignaciones. Contacte con el staff para vincular su cuenta a actividades o estructuras.",
  },
} as const;
